export default __webpack_public_path__ + "dim-b1fe07.json";